import { Controller } from "@hotwired/stimulus";

// GR-4097: shows the registration close input on convert_confirm only while a
// template whose own close has already passed is selected. Each such template
// radio carries data-short-notice. The input is disabled while hidden so a
// prefilled value is not submitted for a template that does not need it.
//
// Admin::EventRequestsController#convert is the source of truth; this is UX.
export default class extends Controller {
  static targets = ["section", "input"];

  toggle(event) {
    const shortNotice = event.target.dataset.shortNotice === "true";

    this.sectionTarget.hidden = !shortNotice;
    this.inputTarget.disabled = !shortNotice;
    this.inputTarget.required = shortNotice;
  }
}
